import { createReducer } from '../../../store.model';

import { ActionType } from './event-centre-dialog.action';
import {
    defaultState,
    EventCentreDialogState,
} from './event-centre-dialog.state';
import { FilterItems, FilterItemsResult } from './state/filter-items.action';
import {
    filterItemsReducer,
    filterItemsResultReducer,
} from './state/filter-items.reducer';
import { ReceiveItems } from './state/receive-items.action';
import { receiveItemsReducer } from './state/receive-items.reducer';
import { Reload } from './state/reload.action';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';
import { Reset } from './state/reset.action';
import { resetReducer } from './state/reset.reducer';
import { SeeItems } from './state/see-items.action';
import { seeItemsReducer } from './state/see-items.reducer';
import { SortItems } from './state/sort-items.action';
import { sortItemsReducer } from './state/sort-items.reducer';
import { ToggleItemExpand } from './state/toggle-item-expand.action';
import { toggleItemExpandReducer } from './state/toggle-item-expand.reducer';
import { ToggleSearch } from './state/toggle-search.action';
import { toggleSearchReducer } from './state/toggle-search.reducer';
import { UpdateItems } from './state/update-items.action';
import { updateItemsReducer } from './state/update-items.reducer';

const { builder, reducer } = createReducer<ActionType, EventCentreDialogState>(
    defaultState(),
);

builder.add<Reload>(ActionType.NOTI__EC__RELOAD, reloadReducer);
builder.add<Reload>(ActionType.NOTI__EC__RELOAD_RESULT, reloadResultReducer);

builder.add<ToggleSearch>(
    ActionType.NOTI__EC__TOGGLE_SEARCH,
    toggleSearchReducer,
);

builder.add<FilterItems>(ActionType.NOTI__EC__FILTER_ITEMS, filterItemsReducer);
builder.add<FilterItemsResult>(
    ActionType.NOTI__EC__FILTER_ITEMS_RESULT,
    filterItemsResultReducer,
);

builder.add<ReceiveItems>(
    ActionType.NOTI__EC__RECEIVE_ITEMS,
    receiveItemsReducer,
);

builder.add<ToggleItemExpand>(
    ActionType.NOTI__EC__TOGGLE_ITEM_EXPAND,
    toggleItemExpandReducer,
);

builder.add<UpdateItems>(ActionType.NOTI__EC__UPDATE_ITEMS, updateItemsReducer);

builder.add<SortItems>(ActionType.NOTI__EC__SORT_ITEMS, sortItemsReducer);

builder.add<SeeItems>(ActionType.NOTI__EC__SEE_ITEMS, seeItemsReducer);

builder.add<Reset>(ActionType.NOTI__EC__RESET, resetReducer);

export const eventCentreDialogReducer = reducer;
